<template>
  <div>
    <span class="headline-section">Unternehmenskalender</span>
    <v-list class="mt-3" v-if="filteredCalendarItems && filteredCalendarItems.length > 0" flat>
      <fin-title-and-time-list-item v-for="(item, index) in filteredCalendarItems"
                                    :key="index"
                                    :item="item"
                                    :border="index !== filteredCalendarItems.length - 1 "
                                    :date-prefix="$options.filters.calendarWeek(item.date) + ' |'"/>
    </v-list>
    <p v-else-if="filteredCalendarItems && filteredCalendarItems.length === 0">Keine Einträge</p>
    <p v-else>Keine Daten verfügbar</p>
  </div>
</template>

<script>
import FinTitleAndTimeListItem from "@/components/common/news/TitleAndTimeListItem"

export default {
  name: "FinCorporateCalendar",
  components: {FinTitleAndTimeListItem},
  props: {
    calendarItems: [Array]
  },
  computed: {
    filteredCalendarItems() {
      const maxDisplayedElements = 4
      let items = [...this.calendarItems]

      try {
        //sort Items
        items.sort((a, b) => {
          let date_a = new Date(a.date).getTime()
          let date_b = new Date(b.date).getTime()
          return date_a < date_b ? -1 : date_a > date_b ? 1 : 0
        })
        //filter past Items
        let firstIndex = items.findIndex((item) => {
          return new Date(item.date).getTime() > new Date().getTime()
        })
        //reduce items
        return items.slice(firstIndex, firstIndex + maxDisplayedElements)
      } catch (e) {
        console.log("Calendar items could not be filtered.", e)
        return items
      }
    }
  }
}
</script>

<style scoped>

</style>
